export const placeOnPlan = (apiClient) => {
    return {
        build(params) {
            return apiClient.request('/standard/placeOnPlane', params);
        },
    };
};
